import { Bug } from 'lucide-react';
import { useKeystoneSession } from '../../auth/use-keystone-session';

import { buildDiagnosticsBundle } from './helpers';
import { downloadJson, getCurrentDateString } from '@helpers';
import { Feature, FeatureHoookParams } from '..';
import { lang } from '@lang';
import { selectCustomerName, useAppSelector } from '@state';
import { useAppToast, useDesign } from '@hooks';

type UseDownloadDiagnosticsFeatureParams = FeatureHoookParams;

export const useDownloadDiagnosticsFeature = (_params: UseDownloadDiagnosticsFeatureParams = {}): Feature<null> => {
	const [controller] = useDesign();
	const { user } = useKeystoneSession();
	const appToast = useAppToast();

	const customerName = useAppSelector(selectCustomerName);
	const blueprintId = controller?.kitchen?.context?.blueprint?.id ?? '';
	const downloadId = blueprintId === '' ? '' : `-${blueprintId.substring(blueprintId.length - 4, blueprintId.length)}`;

	const [disabled, tooltip] = (() => {
		if (!controller) return [true, lang.customer.tooltip.noController];
		return [false, lang.customer.tooltip.downloadDiagnostics];
	})();

	return {
		name: 'downloadDiagnosticsFeature',
		label: lang.customer.label.downloadDiagnostics,
		shortcut: '',
		tooltip,
		icon: (props = {}) => <Bug {...props} />,
		disabled,
		value: null,
		hidden: false,
		handler: () => {
			if (!controller || !controller.kitchen.context.blueprint) return;
			try {
				const bundle = buildDiagnosticsBundle({ controller, userEmail: user?.email ?? null, customerName, blueprintId });
				const filename = `${customerName.toLowerCase().replace(' ', '-')}${downloadId}.${getCurrentDateString()}.diagnostics.json`;
				downloadJson(bundle, filename);
				appToast.success({ title: lang.customer.message.downloadDiagnosticsSuccess });
			} catch (err) {
				console.error('[Download Diagnostics] failed:', err);
				appToast.error({ title: lang.customer.message.downloadDiagnosticsFailed });
			}
		}
	};
};
